import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('UserPermissions', {
    error: (
        <FormattedMessage
            id='front-app/UserPermissions/Notification/Error:title'
            defaultMessage='User Permissions Error'
        />
    ),
    warning: (
        <FormattedMessage
            id='front-app/UserPermissions/Notification/Warning:title'
            defaultMessage='User Permissions Warning'
        />
    ),
    info: (
        <FormattedMessage
            id='front-app/UserPermissions/Notification/Info:title'
            defaultMessage='User Permissions Info'
        />
    ),
    success: (
        <FormattedMessage
            id='front-app/UserPermissions/Notification/Info:title'
            defaultMessage='User Permissions Info'
        />
    ),
});

export const userPermissionsNotifications = {
    updatedSuccessfully: notification.success(appNotification.texts.updatedSuccessfully),
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
